<ng-template #loadingSimulation>
    <div class="d-flex flex-column h-100">
        <ng-container *ngIf="!contract.HasContaCerta">
            <ng-container *ngIf="!this.successUploadReading">
                <edp-loader [size]="'md'" class="text-center my-4"></edp-loader>
                <span class="simulation-load-message text-center">
                    {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.loadingSent' | translate}}
                </span>
            </ng-container>
            <ng-container *ngIf="this.successUploadReading">
                <div class="d-flex flex-column align-items-center simulation-success-message success-reading my-4">
                    <span class="mb-2">
                        <i class="icon icon-edponline-Bop-072"  aria-hidden="true"></i>
                    </span>
                    <span class="success-reading-message">
                        {{  (offlineReading ?
                            "pt.edp.edponline.dashboard.widget.consumptions.simulation.offlineReadingRegistered" :
                            "pt.edp.edponline.dashboard.widget.consumptions.simulation.successUploadReading") | translate }}
                    </span>
                </div>
                <div *ngIf="!offlineReading" class="simulation-alert simulation-load">
                    <edp-loader [size]="'sm'" class="text-center mr-3" *ngIf="offlineReadingNotIndexed"></edp-loader>
                    <ng-container [ngSwitch]="this.contract.getType()">
                        <ng-container *ngSwitchCase="'dual'">
                            <span class="simulation-load-message text-center mb-md-0" *ngIf="activeTab === 'E' && offlineReadingNotIndexed">
                               {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.loadingDataElectricity' | translate}}
                            </span>
                            <span class="simulation-load-message text-center mb-md-0" *ngIf="activeTab === 'G' && offlineReadingNotIndexed">
                               {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.loadingDataGas' | translate}}
                            </span>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <span class="simulation-load-message text-center mb-md-0" *ngIf="offlineReadingNotIndexed">
                               {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.loadingData' | translate}}
                            </span>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-container *ngIf="activeTabActiveMeters && !contract.HasContaCerta &&
    simulation$ |
    async as
    simulation; else
    loadingSimulation">
    <div class="d-flex flex-column h-100" *ngIf="simulation.simulationValue">
        <ng-container #headingBlock [ngSwitch]="this.contract.getType()">
            <ng-container *ngSwitchCase="'dual'">
                <ng-container *ngIf="!hiddenTabActiveMetersSubmitted">
                    <div class="d-flex align-items-center">
                        <span class="simulation-title mr-1"
                            *ngIf="activeTab === 'E'"
                            [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.simulation.prevision'
                            | translate:{
                            'type': 'ContractReadings.Eletricidade' | translate }">
                        </span>
                        <span class="simulation-title mr-1"
                            *ngIf="activeTab === 'G'"
                            [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.simulation.prevision'
                            | translate:{
                            'type': 'ContractReadings.Gas' | translate }"></span>
                        <edp-simulation-tooltip></edp-simulation-tooltip>
                    </div>
                </ng-container>

                <ng-container *ngIf="hiddenTabActiveMetersSubmitted">
                    <div class="d-flex align-items-center">
                        <span
                            class="simulation-title mr-1"
                            [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.simulation.prevision.invoice' | translate"
                        ></span>
                        <edp-simulation-tooltip></edp-simulation-tooltip>
                    </div>
                    <span class="simulation-description">{{
                        'ContractReadings.Eletricidade'
                        | translate }} + {{ 'ContractReadings.Gas' | translate
                        }}
                    </span>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div class="d-flex align-items-center">
                    <span class="simulation-title mr-1"
                        [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.simulation.prevision.invoice'
                        | translate"></span>
                    <edp-simulation-tooltip></edp-simulation-tooltip>
                </div>
                <span *ngIf="activeTab === 'E'"
                    class="simulation-description">{{
                    'ContractReadings.Eletricidade'
                    | translate }}</span>
                <span *ngIf="activeTab === 'G'"
                    class="simulation-description">{{ 'ContractReadings.Gas'
                    | translate }}</span>
            </ng-container>
        </ng-container>
        <ng-container #supplyIconBlock [ngSwitch]="this.contract.getType()">
            <div class="d-flex justify-content-between my-3"
                *ngIf="simulation.simulationValue">
                <div class="d-flex flex-column">
                    <span class="simulation-value"
                        [innerHTML]="simulation.simulationValue |
                        edpDecimalSplit"></span>
                    <span class="simulation-value-description"
                        [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.taxas'
                        | translate"></span>
                </div>
                <span class="icon-type my-auto">
                    <ng-container *ngSwitchCase="'dual'">
                        <ng-container *ngIf="!hiddenTabActiveMetersSubmitted">
                            <i *ngIf="activeTab === 'E'"
                                class="icon {{
                                this.contract.getTypeProperties('electricity').iconBra
                                }}"  aria-hidden="true"></i>
                            <i *ngIf="activeTab === 'G'"
                                class="icon {{
                                this.contract.getTypeProperties('gas').iconBra }}"  aria-hidden="true"></i>
                        </ng-container>

                        <ng-container *ngIf="hiddenTabActiveMetersSubmitted">
                            <i class="icon {{ type.iconBra }}"  aria-hidden="true"></i>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <i class="icon {{ type.iconBra }}"  aria-hidden="true"></i>
                    </ng-container>
                </span>
            </div>
        </ng-container>
        <ng-container #contentBlock [ngSwitch]="this.contract.getType()">
            <div class="d-flex mb-3 mt-2">
                <ng-container *ngSwitchCase="'dual'">
                    <ng-container *ngIf="!hiddenTabActiveMetersSubmitted">
                        <div class="d-flex flex-column">
                            <span class="simulation-type"
                                *ngIf="activeTabActiveMeters.simulation?.realDays
                                &&
                                activeTabActiveMeters.simulation?.estimatedDays">
                                <b>
                                        {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                                        |
                                        translate:{'realDays':
                                        activeTabActiveMeters.simulation?.realDays,
                                        'estimatedDays':
                                        activeTabActiveMeters.simulation?.estimatedDays
                                        } }}
                                    </b>
                                </span>
                            <span class="d-block simulation-description"
                                *ngIf="activeTabActiveMeters.updateReadingOutTime">
                                {{'pt.edp.edponline.dashboard.widget.consumptions.outSideTime'
                                | translate}}</span>
                            <span class="d-block simulation-description"
                                *ngIf="activeTabActiveMeters.updateReadingInTime">
                                {{'pt.edp.edponline.dashboard.widget.consumptions.inSideTime'
                                | translate}}</span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="hiddenTabActiveMetersSubmitted">
                        <div class="d-flex flex-column w-50">
                            <div class="d-flex align-items-center">
                                <span class="simulation-type mr-2">{{
                                    'ContractReadings.Eletricidade'
                                    | translate }}
                                </span>
                                <ng-container
                                    *ngIf="activeTab ===
                                    'E'">
                                    <ng-container
                                        *ngTemplateOutlet="popoverTemplate;
                                        context:{ activeMeters:
                                        activeTabActiveMeters }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="activeTab ===
                                    'G'">
                                    <ng-container
                                        *ngTemplateOutlet="popoverTemplate;
                                        context:{ activeMeters:
                                        hiddenTabActiveMetersSubmitted }"></ng-container>
                                </ng-container>
                            </div>
                            <span class="simulation-type-amount"
                                *ngIf="simulation.electricity">{{
                                simulation.electricity }}€</span>
                        </div>
                        <div class="d-flex flex-column w-50">
                            <div class="d-flex align-items-center">
                                <span class="simulation-type mr-2">{{
                                    'ContractReadings.Gas'
                                    | translate }}</span>
                                <ng-container
                                    *ngIf="activeTab ===
                                    'E'">
                                    <ng-container
                                        *ngTemplateOutlet="popoverTemplate;
                                        context:{ activeMeters:
                                        hiddenTabActiveMetersSubmitted }"></ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="activeTab ===
                                    'G'">
                                    <ng-container
                                        *ngTemplateOutlet="popoverTemplate;
                                        context:{ activeMeters:
                                        activeTabActiveMeters }"></ng-container>
                                </ng-container>
                            </div>
                            <span class="simulation-type-amount"
                                *ngIf="simulation.gas">{{
                                simulation.gas }}€</span>
                        </div>
                    </ng-container>

                </ng-container>
                <ng-container *ngSwitchDefault>
                    <div class="d-flex flex-column w-50"
                        *ngIf="activeTab === 'E'">
                        <div class="d-flex align-items-center">
                            <span class="simulation-type mr-2">{{
                                'ContractReadings.Eletricidade'
                                | translate }}
                            </span>
                            <ng-container *ngTemplateOutlet="popoverTemplate;
                                context:{ activeMeters: activeTabActiveMeters
                                }"></ng-container>
                        </div>
                        <span *ngIf="simulation.electricity"
                            class="simulation-type-amount">{{
                            simulation.electricity }}€
                        </span>
                    </div>
                    <div class="d-flex flex-column w-50"
                        *ngIf="activeTab === 'G'">
                        <div class="d-flex align-items-center">
                            <span class="simulation-type mr-2">{{
                                'ContractReadings.Gas'
                                | translate }}</span>
                            <ng-container *ngTemplateOutlet="popoverTemplate;
                                context:{ activeMeters: activeTabActiveMeters
                                }"></ng-container>
                        </div>
                        <span class="simulation-type-amount"
                            *ngIf="simulation.gas">{{
                            simulation.gas }}€</span>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container #footerBlock [ngSwitch]="this.contract.getType()">
            <ng-container *ngSwitchCase="'dual'">
                <ng-container *ngIf="!hiddenTabActiveMetersSubmitted">
                    <div class="simulation-alert simulation-info">
                        <div class="d-flex justify-content-between">
                            <span *ngIf="activeTab ===
                                'E'"
                                [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.sendReading'
                                | translate:{
                                'type': 'ContractReadings.Gas' |
                                translate | lowercase }"></span>
                            <span *ngIf="activeTab ===
                                'G'"
                                [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.sendReading'
                                | translate:{
                                'type': 'ContractReadings.Eletricidade' |
                                translate |
                                lowercase }"></span>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="hiddenTabActiveMetersSubmitted">
                    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #footerTemplate>
    <div class="simulation-alert" *ngIf="(invoices$ | async)?.invoices.length"
        [ngClass]="isInvoicesAverage
        ?'simulation-success':'simulation-warning'">
        <div class="d-flex justify-content-between w-100"
            *ngIf="!isInvoicesAverage">
            <span>{{'pt.edp.edponline.dashboard.widget.consumptions.outAverage'
                | translate}}</span>
            <span class="ml-3 my-auto">
                <i class="icon icon-edponline-Bop-025"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="d-flex justify-content-between w-100"
            *ngIf="isInvoicesAverage">
            <span>{{'pt.edp.edponline.dashboard.widget.consumptions.insideAverage'
                | translate}}</span>
            <span class="ml-3 my-auto">
                <i class="icon icon-edponline-Bop-072"  aria-hidden="true"></i>
            </span>
        </div>
    </div>
</ng-template>

<ng-template #popoverTemplate let-activeMeters="activeMeters">
    <edp-popover #popComponent [popoverContent]="popoverContent"
        [popBtn]="'icon icon-edponline-Bop-025'">
        <ng-template #popoverContent>
            <span class="d-block simulation-description"
                *ngIf="activeTabActiveMeters.simulation?.realDays &&
                activeTabActiveMeters.simulation?.estimatedDays">
                {{'pt.edp.edponline.dashboard.widget.consumptions.simulation.realAndEstimatedDays'
                |
                translate:{'realDays':
                activeTabActiveMeters.simulation?.realDays,
                'estimatedDays':
                activeTabActiveMeters.simulation?.estimatedDays
                } }}
            </span>
            <span class="d-block simulation-description"
                *ngIf="activeMeters.updateReadingOutTime">{{'pt.edp.edponline.dashboard.widget.consumptions.outSideTime'
                | translate }}</span>
            <span class="d-block simulation-description"
                *ngIf="activeMeters.updateReadingInTime">{{'pt.edp.edponline.dashboard.widget.consumptions.inSideTime'
                | translate}}</span>
        </ng-template>
    </edp-popover>
</ng-template>
